import React from "react";
import { Box } from "@mui/material";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";

interface PrescriptionStatusBadgeProps {
  isActive: boolean;
  isExpired: boolean;
}

const PrescriptionStatusBadge: React.FC<PrescriptionStatusBadgeProps> = ({
  isActive,
  isExpired,
}) => {
  const theme: Theme = useTheme();

  const status = isExpired ? "Expired" : isActive ? "Active" : "Inactive";
  const badgeStyles = getStatusBadgeStyles(status, theme);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "4px 8px",
        border: `1px solid ${badgeStyles.borderColor}`,
        borderRadius: "8px",
        backgroundColor: badgeStyles.backgroundColor,
        width: "fit-content",
      }}
    >
      <Box
        sx={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: badgeStyles.dotColor,
        }}
      />
      <span style={styles.badgeText(theme)}>{status}</span>
    </Box>
  );
};

export default PrescriptionStatusBadge;

const getStatusBadgeStyles = (status: string, theme: Theme) => {
  switch (status) {
    case "Active":
      return {
        borderColor: theme.colorTokens.S[80],
        backgroundColor: "#FFFFFF",
        dotColor: theme.colorTokens.S[70],
      };
    case "Expired":
      return {
        borderColor: theme.colorTokens.D[80],
        backgroundColor: "#FFFFFF",
        dotColor: theme.colorTokens.D[70],
      };
    default:
      return {
        borderColor: theme.colorTokens.N[80],
        backgroundColor: "#FFFFFF",
        dotColor: theme.colorTokens.N[80],
      };
  }
};

const styles = {
  badgeText: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    lineHeight: "19px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
};
